const levels = ['Follow', 'Assist', 'Apply', 'Enable', 'Ensure']

export default levels
